import { ethers } from 'ethers';

export const isValidAddress = (address: string): boolean => {
  if (!address || typeof address !== 'string') return false;
  return ethers.isAddress(address);
};

export const isValidTokenData = (tokenData: {
  name?: string;
  symbol?: string;
  decimals?: number;
  address?: string;
}): boolean => {
  if (!tokenData) return false;
  
  const { name, symbol, decimals, address } = tokenData;
  
  return (
    typeof name === 'string' && 
    name.length > 0 &&
    typeof symbol === 'string' && 
    symbol.length > 0 &&
    typeof decimals === 'number' && 
    decimals >= 0 && 
    decimals <= 18 &&
    isValidAddress(address || '')
  );
};

export const normalizeAddress = (address: string): string => {
  if (!isValidAddress(address)) return address;
  return ethers.getAddress(address);
}; 